import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import {
  BaseActivity,
  BaseActivityArticleName,
  BaseActivityText,
} from '@/components/activities/BaseActivity/BaseActivity';
import IconEdit from '@/icons/Edit.svg';

export const ArticleProcessingServiceAdjustedActivity = ({
  activity,
  displayArticleName,
}: {
  activity: ActivityOfType<'article_processing_service_adjusted'>;
  displayArticleName: boolean;
}) => {
  const creatorName = activity.creator?.name;
  const workshopName = activity.workshop?.name;

  const articleName = (
    <BaseActivityArticleName activity={activity} displayArticleName={displayArticleName} />
  );

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="neutral"
      icon={<IconEdit />}
      message={
        <BaseActivityText>
          {!creatorName ? (
            displayArticleName ? (
              <Trans id="activities.article_processing_service_adjusted.message.automatic.with-changes.with-article">
                <strong>{workshopName}</strong> adjusted the services during processing of the item{' '}
                {articleName}
              </Trans>
            ) : (
              <Trans id="activities.article_processing_service_adjusted.message.automatic.with-changes">
                <strong>{workshopName}</strong> adjusted the services during processing
              </Trans>
            )
          ) : activity.data.withChanges ? (
            displayArticleName ? (
              <Trans id="activities.article_processing_service_adjusted.message.with-changes.with-article">
                <strong>{creatorName}</strong> confirmed services with changes following processing
                of the item {articleName}
              </Trans>
            ) : (
              <Trans id="activities.article_processing_service_adjusted.message.with-changes">
                <strong>{creatorName}</strong> confirmed services with changes following processing
              </Trans>
            )
          ) : displayArticleName ? (
            <Trans id="activities.article_processing_service_adjusted.message.without-changes.with-article">
              <strong>{creatorName}</strong> confirmed services without changes following processing
              of the item {articleName}
            </Trans>
          ) : (
            <Trans id="activities.article_processing_service_adjusted.message.without-changes">
              <strong>{creatorName}</strong> confirmed services without changes following processing
            </Trans>
          )}
        </BaseActivityText>
      }
    />
  );
};
